import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { AchievementUnlockModal, NewAchievement } from '../ui/diary/AchievementUnlockModal';

interface MountOptions {
  /** List of new achievements to display */
  achievements: NewAchievement[];
  /** URL to mark achievements as seen */
  markSeenUrl: string;
  /** CSRF token for API requests */
  csrfToken: string;
  /** Translations for modal content */
  translations: {
    achievementUnlocked: string;
    achievementsUnlocked: string;
    continueButton: string;
  };
}

// Store root reference for cleanup
let root: Root | null = null;

export function mountAchievementUnlockModal(
  container: HTMLElement,
  options: MountOptions
): void {
  // Clean up previous root if it exists
  if (root) {
    root.unmount();
  }

  root = createRoot(container);
  root.render(
    <AchievementUnlockModal
      achievements={options.achievements}
      markSeenUrl={options.markSeenUrl}
      csrfToken={options.csrfToken}
      translations={options.translations}
    />
  );
}

export function unmountAchievementUnlockModal(): void {
  if (root) {
    root.unmount();
    root = null;
  }
}
